import { render, staticRenderFns } from "./UploadSucc.vue?vue&type=template&id=3d753bd4&scoped=true&"
import script from "./UploadSucc.vue?vue&type=script&lang=ts&"
export * from "./UploadSucc.vue?vue&type=script&lang=ts&"
import style0 from "./UploadSucc.vue?vue&type=style&index=0&id=3d753bd4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d753bd4",
  null
  
)

export default component.exports